import { render, staticRenderFns } from "./DateInspection.vue?vue&type=template&id=b0878e90&scoped=true&"
import script from "./DateInspection.vue?vue&type=script&lang=ts&"
export * from "./DateInspection.vue?vue&type=script&lang=ts&"
import style0 from "./DateInspection.vue?vue&type=style&index=0&id=b0878e90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0878e90",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VDatePicker,VMenu,VRow,VSpacer})
